import { BULK_PACKAGE_TYPES, UNPACKED_PACKAGE_TYPES } from 'shared/ncts/common/classifier-util'
import { FieldRequirementResolverContext } from './types'
import { createFieldRequirementGetter, matchServerRequirement } from '../../resolverFactory'
import {
  FieldRequirement,
  FieldRequirementEnvironment,
  FieldRequirementResolverMap, optional, required,
} from '../../../../../models/fieldRules'

function ruleForPackagingNumberOfPackages(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  const packageType = ctx.packaging?.typeOfPackages ?? ''
  if (BULK_PACKAGE_TYPES.includes(packageType) || UNPACKED_PACKAGE_TYPES.includes(packageType)) {
    return 'optional'
  }

  return 'required'
}

function ruleForPackagingShippingMarks(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env
  const packageType = ctx.packaging?.typeOfPackages ?? ''
  if (BULK_PACKAGE_TYPES.includes(packageType) || UNPACKED_PACKAGE_TYPES.includes(packageType)) {
    return 'optional'
  }

  return 'required'
}

function ruleForPassiveBorderTransportMeans(env: FieldRequirementEnvironment<FieldRequirementResolverContext>): FieldRequirement {
  env.ignoreServerRequirement()

  const { ctx } = env

  return ctx.differentPassiveBorderTransportMeans ? 'required' : 'optional'
}

const fieldRequirementResolvers: FieldRequirementResolverMap<FieldRequirementResolverContext> = {
  additionalReference: optional,
  'additionalReference.*.type': required,
  'additionalReference.*.referenceNumber': required,
  commodityDescriptionOfGoods: required,
  differentPassiveBorderTransportMeans: optional,
  goodsMeasureGrossMass: required,
  passiveBorderTransportMeans: ruleForPassiveBorderTransportMeans,
  'passiveBorderTransportMeans.*.identificationNumber': required,
  'passiveBorderTransportMeans.*.typeOfIdentification': required,
  'passiveBorderTransportMeans.*.typeOfMeansOfTransport': required,
  'passiveBorderTransportMeans.*.nationality': required,
  packaging: required,
  'packaging.*.typeOfPackages': required,
  'packaging.*.numberOfPackages': ruleForPackagingNumberOfPackages,
  'packaging.*.shippingMarks': ruleForPackagingShippingMarks,
  'supportingDocument.*.documentType': required,
  'transportDocument.*.documentType': required,
  transportEquipment: optional,
  'transportEquipment.*.containerSizeAndType': required,
  'transportEquipment.*.packedStatus': required,
  'transportEquipment.*.supplierType': required,
  'transportEquipment.*.containerIdentificationNumber': required,
  'transportEquipment.*.seals.*.identifier': required,
}

function getServerRequirementForPath(
  path: string,
  ctx: FieldRequirementResolverContext,
) {
  return matchServerRequirement(ctx.serverFieldRequirements, path)
}

const getFieldRequirement = createFieldRequirementGetter<FieldRequirementResolverContext>(
  fieldRequirementResolvers,
  getServerRequirementForPath,
)

export default getFieldRequirement
